import React, { ReactElement } from 'react';

interface CompanyViewInfoMetadataItemProps {
    label: string;
    content: string | ReactElement;
}

const CompanyViewInfoMetadataItem: React.FC<CompanyViewInfoMetadataItemProps> = ({ label, content }): ReactElement => (
    <div className="company-view-info__metadata-item">
        <div className="company-view-info__metadata-label">
            {`${label}:`}
        </div>
        <div className="company-view-info__metadata-content">
            {content}
        </div>
    </div>
);

export default CompanyViewInfoMetadataItem;
